export * from "./dictionary";
export * from "./translation";
export { translate as __ } from "./translation";
//# sourceMappingURL=index.js.map